import { ErrorHandler, ModuleWithProviders, NgModule } from '@angular/core';
import { CognitoAuthService } from '@techspert-io/auth';
import { RaygunErrorHandler } from './services/raygun-error-handler.service';
import { RAY_GUN, RAY_GUN_API_KEY, getRaygunFactory } from './services/tokens';

@NgModule()
export class ErrorHandlingModule {
  static forRoot(apiKey: string): ModuleWithProviders<ErrorHandlingModule> {
    return {
      ngModule: ErrorHandlingModule,
      providers: [
        {
          provide: RAY_GUN_API_KEY,
          useValue: apiKey,
        },
        {
          provide: RAY_GUN,
          useFactory: getRaygunFactory,
          deps: [RAY_GUN_API_KEY],
        },
        {
          provide: ErrorHandler,
          useClass: RaygunErrorHandler,
          deps: [RAY_GUN, CognitoAuthService],
        },
      ],
    };
  }
}
